import React from "react";
import '../Style.css';
import {
    BrowserRouter as Router,
    Routes,
    Route,
    Link,
} from "react-router-dom";
import $ from "jquery";
import logo from '../Assets/Images/logo-short.png';
import logo2 from '../Assets/Images/Milton_Logo.png';
import AllCategory from '../Pages/AllCategory.js';


function Navbar() {
    return (
        <div>

            <nav class="navbar navbar-expand-lg py-0">
                <div class="container-fluid">
                    <a class="navbar-brand" href="/">
                        <img src={logo} />
                        {/* <p className="">The value of weighing</p> */}
                    </a>
                    <a class="navbar-brand-2 ms-5 ps-4" href="/">
                        <img className="" src={logo2} />
                        {/* <p className="">The value of weighing</p> */}
                    </a>
                    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button>


                    <div class="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul class="navbar-nav mx-auto mb-2 mb-lg-0">
                            <li class="nav-item">
                                <a class="nav-link " aria-current="page" href="/">Home</a>
                            </li>

                            <li class="nav-item">
                                <a class="nav-link " aria-current="page" href="/#aboutsection">About Us</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link " aria-current="page" href="/AllCategory">Products</a>
                            </li>
                            {/* <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    Products
                                </a>
                                <ul class="dropdown-menu">
                                    <li><a class="dropdown-item" href="#">Action</a></li>
                                    <li><a class="dropdown-item" href="#">Another action</a></li>

                                </ul>
                            </li> */}
                            <li class="nav-item">
                                <a class="nav-link" href="/#footer-section" >Contact Us</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>




        </div >

    );
}

export default Navbar;
